import { apiClient } from "@/services/services";
import { TAGS } from "@/globalConsts/queryParams";
import type { AxiosResponse } from "axios";

export async function fetchDestinations(internalApi: string) {
  try {
    const searchParams = new URLSearchParams(location.search);

    if (!searchParams.has(TAGS)) {
      return "";
    }

    const response: AxiosResponse = await apiClient.get(
      `${internalApi}destinations?${TAGS}=${searchParams.get(TAGS)}`
    );

    const destinationList: string[] = response.data.response;

    return destinationList.length > 0 ? destinationList.join(", ") : "";
  } catch (e) {
    if (e instanceof Error) {
      console.error("destinations " + e.message);
    }
  }
}
